const ABTest = (() => {
  const COOKIE_KEY    = 'product_image_ab';
  const EXPERIMENT_ID = 'product-image-v2';

  // ── Bucket assignment ──────────────────────────────────────────────────────
  // Each visitor is assigned once and stays in the same bucket for 30 days.

  function getBucket() {
    const stored = getCookie(COOKIE_KEY);
    if (stored) return stored;
    const bucket = Math.random() < 0.65 ? 'control' : 'variant';
    setCookie(COOKIE_KEY, bucket, 30);
    return bucket;
  }

  // ── Main image swap ────────────────────────────────────────────────────────

  function applyImageTest() {
    const carousel = document.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    const variantItems = carousel.querySelectorAll('.product-gallery__carousel-item.ab-variant');
    const controlItems = carousel.querySelectorAll('.product-gallery__carousel-item.ab-control');

    // No B images on this product — skip entirely
    if (!variantItems.length) return;

    const bucket = getBucket();

    // Fire impression event with full context
    pushEvent('ab_test_impression', bucket, {
      product_id:   getProductId(),
      product_name: getProductName(),
      image_set:    bucket === 'variant' ? 'B' : 'A',
    });

    if (bucket === 'variant') {

  controlItems.forEach(el => {
    el.style.display = 'none';
    el.classList.remove('is-selected');
  });

  variantItems.forEach((el, i) => {
    el.style.display = '';
    el.classList.toggle('is-selected', i === 0);
  });

  document.querySelectorAll('.product-gallery__thumbnail.ab-control')
    .forEach(el => {
      el.style.display = 'none';
      el.classList.remove('is-nav-selected');
    });

  document.querySelectorAll('.product-gallery__thumbnail.ab-variant')
    .forEach((el, i) => {
      el.style.display = '';
      el.classList.toggle('is-nav-selected', i === 0);
    });

} else {

  // SHOW CONTROL
  controlItems.forEach((el, i) => {
    el.style.display = '';
    el.classList.toggle('is-selected', i === 0);
  });

  // HIDE VARIANT
  variantItems.forEach(el => {
    el.style.display = 'none';
    el.classList.remove('is-selected');
  });

  document.querySelectorAll('.product-gallery__thumbnail.ab-control')
    .forEach((el, i) => {
      el.style.display = '';
      el.classList.toggle('is-nav-selected', i === 0);
    });

  document.querySelectorAll('.product-gallery__thumbnail.ab-variant')
    .forEach(el => {
      el.style.display = 'none';
      el.classList.remove('is-nav-selected');
    });
}
  }

  // ── ATC + purchase tracking ────────────────────────────────────────────────

  function bindFormTracking() {
    document.querySelectorAll('form.product-form').forEach(form => {
      form.addEventListener('submit', () => {
        const CONTROL_WEIGHT = 0.9;

        const bucket =
        Math.random() < CONTROL_WEIGHT
            ? 'control'
            : 'variant';
        pushEvent('ab_test_add_to_cart', bucket, {
          product_id:   getProductId(),
          product_name: getProductName(),
          image_set:    bucket === 'variant' ? 'B' : 'A',
        });
      });
    });
  }

  // ── Helper: read product data from the JSON block in product-info.liquid ──

  function getProductData() {
    try {
      const jsonBlock = document.querySelector('[data-product-json]');
      return jsonBlock ? JSON.parse(jsonBlock.textContent).product : null;
    } catch (e) {
      return null;
    }
  }

  function getProductId() {
    return getProductData()?.id ?? null;
  }

  function getProductName() {
    return getProductData()?.title ?? null;
  }

  // ── GA4 dataLayer push ─────────────────────────────────────────────────────

  function pushEvent(eventName, bucket, extra = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event:         eventName,
      experiment_id: EXPERIMENT_ID,
      variant:       bucket,
      ...extra,
    });
  }

  // ── Cookie helpers ─────────────────────────────────────────────────────────

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
  }

  function getCookie(name) {
    return document.cookie.split('; ').reduce((r, c) => {
      const [k, v] = c.split('=');
      return k === name ? v : r;
    }, null);
  }

  return { applyImageTest, bindFormTracking, getBucket };
})();

document.addEventListener('DOMContentLoaded', () => {
  ABTest.applyImageTest();
  ABTest.bindFormTracking();
});